import { api } from "@/APIRequests";
import type { PatientStrengthAndCautionOptionsResponse } from "@/core/types";

export async function getStrengthCautionOptions(
  patientId: string,
): Promise<PatientStrengthAndCautionOptionsResponse> {
  return api.carePlanTyped.get_patient_strength_and_caution_options({
    params: { showLoader: false },
    patientId,
  });
}
